import { BarChart } from "@mui/x-charts/BarChart";
import filter from "../../../assets/filter.svg";
import { useState } from "react";
import FilterLayout from "../../../components/layouts/FilterLayout";
import MultiSelectFilter from "../../../components/reusable/MultiSelectFilterForCheckbox";
import { message } from "antd";
import FilterDates from "../../../components/reusable/FilterDates";

export default function TotalTripSummary({ data, xLabels, companyList, shiftTimeList, TripTypeList, vehicleTypeList, filters, setFilters, userCompany }) {
  const [isFilterOpen, setIsFilterOpen] = useState(false);


  // Function to update a specific filter
  const updateFilter = (filterName, value) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [filterName]: value,
    }));
  };

  const handleClearFilter = () => {
    message.success("cleared filters of Total Trip Summary");
    setFilters({
      company: [],
      vehicleType: [],
      shiftTime: [],
      tripType: [],
    })
    setIsFilterOpen(!isFilterOpen);
  };

  // Replace these arrays with your actual data
  const companyOptions = companyList?.map(item => item);
  const shiftTimeOptions = shiftTimeList?.map(item => item);
  const tripTypeOptions = TripTypeList?.map(item => item);
  const vehicleTypeOptions = vehicleTypeList?.map(item => item);

  const filterContent = [
    {
      title: "Company",
      body: (
        <div className=" w-full flex gap-3 items-center   ">
          <div>
            <MultiSelectFilter
              label="Company"
              options={companyOptions}
              selectedOptions={filters.company}
              updateSelectedOptions={(selected) =>
                updateFilter("company", selected)
              }
              displayValue="name"
              returnValue="id"
            />
          </div>
        </div>
      ),
    },
    {
      title: "Shift Time",
      body: (
        <div>
          <MultiSelectFilter
            label="Shift Time"
            options={shiftTimeOptions}
            selectedOptions={filters.shiftTime}
            updateSelectedOptions={(selected) =>
              updateFilter("shiftTime", selected)
            }
            displayValue="name"
            returnValue="id"
          />
        </div>
      ),
    },
    {
      title: "Trip Type",
      body: (
        <div>
          <MultiSelectFilter
            label="Trip Type"
            options={tripTypeOptions}
            selectedOptions={filters.tripType}
            updateSelectedOptions={(selected) =>
              updateFilter("tripType", selected)
            }
            displayValue="name"
            returnValue="id"
          />
        </div>
      ),
    },
    {
      title: "Vehicle Type",
      body: (
        <div>
          <MultiSelectFilter
            label="Vehicle Type"
            options={vehicleTypeOptions}
            selectedOptions={filters.vehicleType}
            updateSelectedOptions={(selected) =>
              updateFilter("vehicleType", selected)
            }
            displayValue="name"
            returnValue="id"
          />
          {/* Date inputs go here */}
        </div>
      ),
    },

  ];

  const filterContentForLapiz = [
    {
      title: "Shift Time",
      body: (
        <div>
          <MultiSelectFilter
            label="Shift Time"
            options={shiftTimeOptions}
            selectedOptions={filters.shiftTime}
            updateSelectedOptions={(selected) =>
              updateFilter("shiftTime", selected)
            }
            displayValue="name"
            returnValue="id"
          />
        </div>
      ),
    },
    {
      title: "Trip Type",
      body: (
        <div>
          <MultiSelectFilter
            label="Trip Type"
            options={tripTypeOptions}
            selectedOptions={filters.tripType}
            updateSelectedOptions={(selected) =>
              updateFilter("tripType", selected)
            }
            displayValue="name"
            returnValue="id"
          />
        </div>
      ),
    },
    {
      title: "Vehicle Type",
      body: (
        <div>
          <MultiSelectFilter
            label="Vehicle Type"
            options={vehicleTypeOptions}
            selectedOptions={filters.vehicleType}
            updateSelectedOptions={(selected) =>
              updateFilter("vehicleType", selected)
            }
            displayValue="name"
            returnValue="id"
          />
          {/* Date inputs go here */}
        </div>
      ),
    },

  ];

  // const xLabels = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const colors = [
    "#52D3D8",
    "#009EFF",
    "#FF7F50",
    "#FFD700",
    "#32CD32",
    "#FF6347",
    "#8A2BE2",
    // Add more colors as needed
  ];

  return (
    <>
      <div className="shadow-lg p-4 pl-6 pt-6  hidden lg:flex flex-col flex-auto xl:max-w-[650px] border rounded-md relative">
        <div className="absolute m-4 border border-border-gray rounded-lg top-0 right-0">
          <FilterLayout
            isFilterOpen={isFilterOpen}
            setIsFilterOpen={setIsFilterOpen}
            content={userCompany == "lapiz" ? filterContentForLapiz : filterContent}
            handleClearFilter={handleClearFilter}
          />
        </div>
        <p className="text-lg font-semibold w-fit">Total Trip Summary</p>
        <BarChart
          width={600}
          height={300}
          series={[
            {
              data: data,
              label: "Total Trip",
              id: "totalData",
              // color: colors,
              color: "#52D3D8",
            },
          ]}
          xAxis={[{ data: xLabels, scaleType: "band" }]}
          slotProps={{
            legend: { hidden: true },
          }}
        />
        {/* <div className="flex gap-4 justify-center items-center">
                <div className="flex gap-2 justify-center items-center">
                    <div className="w-3 h-3 rounded-full bg-[#52D3D8]" />
                    <p>Total</p>
                </div>
                <div className="flex gap-2 justify-center items-center">
                    <div className="w-3 h-3 rounded-full bg-[#009EFF]" />
                    <p>Alotted</p>
                </div>
            </div> */}
      </div>
      <div className="shadow-lg px-4  pt-6  flex lg:hidden flex-col flex-auto 2xl:max-w-[55%] h-fit border rounded-md relative">
        <div className="absolute m-4 border border-border-gray rounded-lg top-0 right-0">
          <FilterLayout
            isFilterOpen={isFilterOpen}
            setIsFilterOpen={setIsFilterOpen}
            content={userCompany == "lapiz" ? filterContentForLapiz : filterContent}
            handleClearFilter={handleClearFilter}
          />
        </div>
        <p className="text-lg font-semibold w-fit">Total Trip Summary</p>
        <BarChart
          width={300}
          height={300}
          series={[
            {
              data: data,
              label: "Total Trip",
              id: "totalData",
              color: "#52D3D8",
            },
          ]}
          xAxis={[{ data: xLabels, scaleType: "band" }]}
          slotProps={{
            legend: { hidden: true },
          }}
        />
        {/* <div className="flex gap-4 justify-center items-center">
                <div className="flex gap-2 justify-center items-center">
                    <div className="w-3 h-3 rounded-full bg-[#52D3D8]" />
                    <p>Total</p>
                </div>
                <div className="flex gap-2 justify-center items-center">
                    <div className="w-3 h-3 rounded-full bg-[#009EFF]" />
                    <p>Alotted</p>
                </div>
            </div> */}
      </div>
    </>
  );
}
